import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {},
			adsensConfig: {
				home_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_1: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_2: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_3: {
					style: 'display:block',
					'data-ad-client': '',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
			},

			domainConfig: {
				showBlog: 1,
				blog: [3, 5, 7, 11, 20, 26, 33, 37, 43, 45],
				origin: 'Japanese',
				siteName: 'Naming',
				siteIcon: '/icon/8.svg',
				IAMEMAIL: 'nameailab.support@gmail.com',
				IAmURL: 'nameailab.com',
				ABOUTUS: "We blend tradition and technology to craft unique baby names with AI. Our intelligent naming lab delivers meaningful, personalized names rooted in culture, language, and your family's values.",
				meta: {
					title: ' | Smart Name Lab for Babies',
					des: 'Discover unique and meaningful baby names with our AI-powered name lab. Generate personalized names based on your preferences and cultural background in seconds.',
				},
				firebase: {},
				ads: '',
				adsense: {
					scriptUrl: '',
				},
			},
			gender: [],
			style: [],
			meaning: [],
			nameOverview: {
				total: 0,
				genderDistribution: {},
				styleDistribution: {},
				syllableDistribution: {},
			},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setGender(state, gender) {
				state.gender = gender
			},
			setStyle(state, style) {
				state.style = style
			},
			setMeaning(state, meaning) {
				state.meaning = meaning
			},
			setNameOverview(state, nameOverview) {
				state.nameOverview = nameOverview
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			gender: (state) => state.gender,
			style: (state) => state.style,
			meaning: (state) => state.meaning,
			nameOverview: (state) => state.nameOverview,
		},
	})
}
